import React, { ReactNode } from 'react';
import { Avatar, AvatarSizes, ZigImageInput } from '@zignaly-open/ui';
import { useGetServiceLogo } from 'util/images';
import { uploadImage } from 'apis/cloudinary';
import { useToast } from '../../../../util/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { whitelabelSpecificSwitches } from '../../../../whitelabel';

const maxUploadSize = 150;

const ServiceLogo = ({
  label,
  value,
  size = 'xx-large',
  onChange,
  id,
}: {
  label: string | ReactNode;
  value: string;
  size?: `${AvatarSizes}` | number;
  onChange: (logo: string) => void;
  id?: string;
}) => {
  const toast = useToast();
  const getServiceLogo = useGetServiceLogo();
  const { t } = useTranslation('common');

  return (
    <ZigImageInput
      buttonLabel={label}
      sx={{ alignItems: 'center' }}
      uploadFn={async (file: File) => {
        try {
          const upload = await uploadImage(file, { maxUploadSize });
          return upload.secure_url;
        } catch (e) {
          console.error(e);
          toast.error(
            e === 'Max size'
              ? t('max-upload-size', { threshold: maxUploadSize })
              : e.toString(),
          );
        }
      }}
      renderer={(url: string) => (
        <Avatar
          size={size}
          alt={''}
          square={!whitelabelSpecificSwitches.allowCustomServiceImages}
          image={getServiceLogo(url)}
          id={id}
        />
      )}
      id={'edit-profile__logo'}
      value={getServiceLogo(value)}
      onChange={onChange}
    />
  );
};

export default ServiceLogo;
